import React from "react";

type HTMLTag = keyof JSX.IntrinsicElements;

export type HeaderProps = {
    title: string;
    renderAs?: HTMLTag;
    className?: string;
};

const Header: React.FC<HeaderProps> = ({ title, renderAs = "h1", className }) => {
    const Tag = renderAs as HTMLTag;
    return <Tag className={className}>{title}</Tag>;
};

export default Header;
